module.exports = __webpack_public_path__ + "static/media/alert-grey.85e22c6c.svg";